import RegionTally from './RegionTally';
import AwardsDataBuilder from './AwardsDataBuilder';

class AwardsRegionData extends AwardsDataBuilder {
  constructor(data = {}, totals = {}) {
    super(data, totals, AwardsRegionData.buildRegionsTallyObservable);
  }

  static buildRegionsTallyObservable(data) {
    return Object.entries(data)
      .map(([region, regionData]) => RegionTally.fromObjectObservable(regionData, region));
  }

  static buildResolvedRegionsTally(data) {
    const regionTallyObservables = AwardsRegionData.buildRegionsTallyObservable(data);

    // Using Promise.all to resolve the observables
    return Promise.all(regionTallyObservables.map((obs) => obs.toPromise()))
      .then((resolvedRegionTallyArray) => resolvedRegionTallyArray); // Direct return without block
  }
}

export default AwardsRegionData;
